<template>
<div>
  <Header title="个人资料" />
  <div class="head-portrait">
    <img :src="getAvatar(avatarImageUri)"/>
  </div>

  <div class="center-info">
    <div class="center-info-item center-item-box" >
      <van-cell title="姓名" :value="clientUserInfo.userName" />
      <van-cell title="手机号" :value="clientUserInfo.userMobile" />
      <van-cell title="已获得积分" :value="clientUserInfo.pointDTO && clientUserInfo.pointDTO.pointValue" />
      <van-cell title="人员身份" :value="clientUserInfo.userRoleName" />
    </div>
  </div>
  <div class="bottom-btn" v-if="userStatus==1">
    <div class="normal-btn" @click="selectOverlay=true">身份设置</div>
    <div class="normal-btn" @click="forbiddenOverlay=true">账号注销</div>
  </div>
  <div class="bottom-btn" v-if="userStatus==2">
    <div class="normal-btn" @click="forbiddenOverlay=true">账号启用</div>
  </div>

  <van-overlay :show="selectOverlay" @click="selectOverlay = false">
    <div class="wrapper-overlay" @click.stop>
      <div class="content-overlay">
        <div class="overlay-cancel" @click="selectOverlay = false">x</div>
        <div class="content-title">设置人员身份</div>
        <div class="select-type-box box-shadow" >
          <van-radio-group v-model="userRole" class="select-type"  checked-color="#00545e">
            <van-radio name="02" ><span class="color-ccc" :class="{'active': userRole === '02'}">负责人</span></van-radio>
            <div style="margin-left:25px"  :class="{'active': userRole === '02'}">扫码积分、积分记录查看、积分使用、券包兑换权限</div>
            <van-radio name="03"><span class="color-ccc" :class="{'active': userRole === '03'}">修理工</span></van-radio>
            <div style="margin-left:25px"  :class="{'active': userRole === '03'}">扫码积分、仅添加购物车（不可使用积分或券包）</div>
          </van-radio-group>
        </div>
        <div class="overlay-btn" @click="changeRole()">确定</div>
        <!-- <img src="../dialog-bg.png"></img> -->
      </div>
    </div>
  </van-overlay>

  <van-overlay :show="forbiddenOverlay" @click="forbiddenOverlay = false">
    <div class="wrapper-overlay" @click.stop>
      <div class="content-overlay">
        <div class="overlay-cancel" @click="forbiddenOverlay = false">x</div>
        <div class="content-title">是否确认{{`${clientUserInfo.userStatus==1?'禁用':'启用'}`}}该账号？</div>
        <div class="overlay-block"></div>
        <div class="overlay-btn" @click="handleForbidden()">确定</div>
        <!-- <img src="../dialog-bg.png"></img> -->
      </div>
    </div>
 </van-overlay>

  <van-overlay :show="hintOverlay" @click="hintOverlay = false">
    <div class="wrapper-overlay" @click.stop>
      <div class="content-overlay">
        <div class="overlay-cancel" @click="hintOverlay = false">x</div>
        <div v-if="btnType==='forbidden'">
          <div class="content-title">操作成功</div>
          <div class="overlay-block"></div>
        </div>
        <div v-if="btnType==='userRole'">
          <div class="content-title">操作成功</div>
          <div class="content-info">
            <van-icon class="overlay-icon" name="passed" size="40" color="#00545e"/>
            <div>该人员身份为{{userRole==='02'?'负责人':'修理工'}}</div>
          </div>
        </div>
        <div class="overlay-btn" @click="hintOverlay = false;selectOverlay = false">确定</div>
        <!-- <img src="../dialog-bg.png"></img> -->
      </div>
    </div>
 </van-overlay>

</div>
</template>

<script>
import Header from '@/components/header'
import { userUtils } from '@/utils/auth'
import centerApi from '@/api/center'
import { commonUtils } from '@/utils/common'
export default {
  components: {
    Header
  },
  data () {
    return {
      pointList: [],
      couponListLength: 0,
      userInfo: {},
      clientUserId: '',
      clientUserInfo: {},
      selectOverlay: false,
      userRole: '',
      forbiddenOverlay: false,
      userStatus: '',
      hintOverlay: false,
      btnType: 'userRole',
      avatarImageUri: ''
    }
  },
  created () {
    this.init()
    this.userInfo = userUtils.getClientInfo()
  },
  methods: {
    init () {
      this.clientUserId = this.$route.query.clientUserId
      this.queryClientUserInfo()
    },
    getAvatar (img) {
      return commonUtils.getImageUrl(img)
    },
    queryClientUserInfo () {
      let params = {
        clientUserId: this.clientUserId
      }
      centerApi.queryClientUserInfo(params).then(res => {
        if (res.data.resultCode === '0') {
          this.clientUserInfo = res.data.resultData.clientUserInfo
          this.userRole = this.clientUserInfo.userRole
          this.userStatus = this.clientUserInfo.userStatus
          this.avatarImageUri = this.clientUserInfo.avatarImageUri
        }
      })
    },
    queryCouponList () {
      centerApi.queryCouponList().then(res => {
        if (res.data.resultCode === '0') {
          this.couponListLength = res.data.resultData.couponTotal || 0
        }
      })
    },
    toUserIntegration () {
      this.$router.push({ name: 'user-integration' })
    },
    gotoWeb (name) {
      console.log(name)
      this.$router.push({ name })
    },
    changeRole () {
      let data = {
        clientUserId: this.clientUserInfo.clientUserId,
        userRole: this.userRole
      }
      this.clientUserWorkshopUpdateStatus(data)
      this.btnType = 'userRole'
    },
    handleForbidden () {
      let data = {
        clientUserId: this.clientUserInfo.clientUserId,
        userStatus: this.userStatus === 1 ? 2 : 1
      }
      this.clientUserWorkshopUpdateStatus(data)
      this.forbiddenOverlay = false
      this.btnType = 'forbidden'
    },
    clientUserWorkshopUpdateStatus (data) {
      centerApi.clientUserWorkshopUpdateStatus(data).then(res => {
        if (res.data.resultCode === '0') {
          this.queryClientUserInfo()
          this.hintOverlay = true
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
/* 头像 */
.head-portrait{
    position: relative;
    width: 100%;
    height: 120px;
    padding-top: 46px;
    img{
      width: 80px;
      height: 80px;
      border-radius: 50%;
      margin-left: calc(50% - 40px);
      margin-top: 30px;
      margin-bottom: 20px;
    }
}
.center-head-portrait .center-head-portrait-bg{
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 9;
}
.center-head-portrait .center-head-portrait-wrapper{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 3.25rem;
    height: 3.25rem;
    -webkit-transform: translate(-50%,-50%);
            transform: translate(-50%,-50%);
    z-index: 10;
}
.center-head-portrait .center-head-portrait-icon{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1.95rem;
    height: 1.95rem;
    -webkit-transform: translate(-50%,-50%);
            transform: translate(-50%,-50%);
    z-index: 10;
}

.center-info{
  margin: 0 15px;
  width: calc(100% - 30px);
}
.center-info-item{
  margin-top: 15px;
  padding-top: 0.1rem;
  padding-bottom: 0.06rem;
  background-color: #fff;
  border-radius: 5px;
}

.center-item-box{
  margin-top: 10px;
  align-items: center;
  vertical-align: middle;
  img{
    position: absolute;
    top: 12px;
    width: 18px;
    margin-right: 10px;
  }
  .custom-title{
    padding-left: 30px;
  }
}

.bottom-btn{
  position: fixed;
  bottom: 0px ;
  width: 80%;
  left: 10%;
}
.normal-btn{
  width: 100%;
  height: 40px;
  color: var(--base-green);
  border: solid 1px var(--base-green);
  text-align: center;
  line-height: 40px;
  border-radius: 6px;
  font-weight: 600;
  margin: 15px 0;
}
.select-type{
  color:#ccc;
   .active{
    color:var(--base-green);
  }
}
.color-ccc{
  color:#ccc;
}
</style>
